import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from './store'
import { AdminShell } from './components/shell/AdminShell'
import { LoginPage } from './features/auth/LoginPage'
import { CmsPage } from './features/cms/CmsPage'
import { CustomerDetailPage } from './features/customers/CustomerDetailPage'
import { CustomerFormPage } from './features/customers/CustomerFormPage'
import { CustomersPage } from './features/customers/CustomersPage'
import { DashboardPage } from './features/dashboard/DashboardPage'
import { GalleryPage } from './features/gallery/GalleryPage'
import { BroadcastFormPage } from './features/notifications/BroadcastFormPage'
import { BroadcastsPage } from './features/notifications/BroadcastsPage'
import { NotificationsPage } from './features/notifications/NotificationsPage'
import { OfferFormPage } from './features/offers/OfferFormPage'
import { OffersPage } from './features/offers/OffersPage'
import { OrderDetailPage } from './features/orders/OrderDetailPage'
import { OrdersPage } from './features/orders/OrdersPage'
import { ProductFormPage } from './features/products/ProductFormPage'
import { ProductListPage } from './features/products/ProductListPage'
import { NotFoundPage } from './features/settings/NotFoundPage'
import { SettingsPage } from './features/settings/SettingsPage'

function App() {
  const token = useSelector((root: RootState) => root.auth.token)

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to={token ? '/dashboard' : '/login'} />} />
      <Route path="/login" element={token ? <Navigate replace to="/dashboard" /> : <LoginPage />} />

      <Route element={<AdminShell />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/products" element={<ProductListPage />} />
        <Route path="/products/new" element={<ProductFormPage mode="new" />} />
        <Route path="/products/:id" element={<ProductFormPage mode="edit" />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/cms" element={<CmsPage />} />
        <Route path="/offers" element={<OffersPage />} />
        <Route path="/offers/new" element={<OfferFormPage mode="new" />} />
        <Route path="/offers/:id/edit" element={<OfferFormPage mode="edit" />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/:id" element={<CustomerDetailPage />} />
        <Route path="/customers/:id/edit" element={<CustomerFormPage mode="edit" />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/notifications/broadcasts" element={<BroadcastsPage />} />
        <Route path="/notifications/broadcasts/new" element={<BroadcastFormPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default App
